import styled from 'styled-components';
import { tableDataStyles, tableHeaderStyles, tableRowStyles, tableStyles } from '../../../base/table/table';

export const Wrapper = styled.div`
	table {
		${tableStyles};
		height: auto !important;
		width: 100% !important;
		max-width: 100vw;
		overflow-x: auto;
	}

	tr {
		${tableRowStyles};
	}

	th {
		${tableDataStyles};
		${tableHeaderStyles};
		padding-left: 1.5rem;
	}

	td {
		${tableDataStyles};
		padding-left: 1.5rem;
	}
`;
